import LegalPage from '../components/ui/LegalPage.jsx'

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      description="FastAudio Terms of Service — acceptable use policy, disclaimer of warranties, and limitation of liability for the conversion service."
      slug="terms"
      lastUpdated="January 2025"
    >
      <p>
        By using FastAudio you agree to these Terms of Service. Please read them carefully.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Acceptable Use</h2>
      <p>
        FastAudio is provided for personal, non-commercial use only. You may only convert content
        that you own or have explicit permission to convert. Downloading copyrighted content
        without authorisation is prohibited and is solely your responsibility.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">No Warranty</h2>
      <p>
        The service is provided "as is" without warranty of any kind. We do not guarantee
        uninterrupted availability, accuracy of results, or compatibility with any specific
        platform or device.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Limitation of Liability</h2>
      <p>
        FastAudio shall not be liable for any direct, indirect, incidental, or consequential
        damages arising from your use of the service, including but not limited to copyright
        infringement claims resulting from your actions.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Changes to Terms</h2>
      <p>
        We reserve the right to modify these terms at any time. Continued use of the service
        following any changes constitutes acceptance of the new terms.
      </p>

      <p className="mt-6 pt-4 border-t border-border/50 text-xs">
        For the current version of these terms, visit{' '}
        <a href="https://fastaudio.cc/terms" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
          fastaudio.cc/terms
        </a>.
      </p>
    </LegalPage>
  )
}
